<template>
    <div class="w100" style=" background: #01033c;">
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/active2020.png" alt="" srcset="" style="width: 340px;"><br>
                    <img src="../../assets/images/ej/meeting_title1.png" alt="" srcset="" style="width: 1000px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2021 · 中国 · 唐山</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2020年12月10日，地点：唐山香格里拉大酒店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>2020年在新冠病毒蔓延之下，全球主要发达经济体陷入困境。中国的疫情防控和经济应对措施及时有力，经济平稳运行。供给侧结构性改革持续深化，行业整合加速；钢铁生产快速恢复，粗钢表观消费显著增长，市场形势良好。但原料供需矛盾突出，钢企利润有所下降。为深入分析新形势下钢铁行业的机遇和挑战，总结2020年钢铁行业和市场特点，研讨2021年行业和市场运行趋势，交流大数据在钢铁企业经营中的应用经验，分享中间市场带来的新交易机会，全联冶金商会和河北唐宋大数据产业股份有限公司共同主办2020年钢铁产业链年度论坛，暨“中国钢铁产业网”年会。</p>
                </div>
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;程</span></p>
                    <div class="meeting-yc-content center mt30">
                        <h2>
                            <span>前置论坛</span><br>
                            <span>12月9日 下午</span>
                        </h2>
                        <div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:00 - 15:45</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">领导致辞</span>
                                <span class="right-text">
                                    河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                    日照大宗商品交易中心总经理
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    冯益朋
                                </span>
                                <a class="shuline"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:45 - 16:15</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《黑色调期实战案例分析》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司总经理 张品</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:15 - 16:45</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《唐宋的数据和算法》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司副总经理 马强</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:45 - 17:45</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">嘉宾互动研讨</span>
                                <span class="right-text">
                                    日照大宗商品交易中心总经理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;冯益朋<br>
                                    杭州国祝联成实业有限公司总经理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;张玺<br>
                                    上海鸿凯投资有限公司副总经理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;胡卫东<br>
                                    唐山金马钢铁集团有限公司总经理助理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;马海岩<br>
                                    秦皇岛佰工钢铁有限公司副总经理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;毛汝男<br>
                                    中航国际钢铁贸易有限公司总经理助理 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;金良米
                                </span>
                                <a class="shuline" style="height: 175px"></a>
                            </p>
                            <p class="time-line-content" style="margin-top: 15px;">
                                <span class="fontWhite font14">18:00 - 20:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">晚宴</span>
                                <!-- <a class="shuline" style="height: 40px"></a> -->
                            </p>
                        </div>

                        
                    </div>

                    <div class="meeting-yc-content center mt40">
                        <h2>
                            <span>主论坛</span><br>
                            <span>12月10日</span>
                        </h2>
                        <div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">08:50 - 12:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">致辞演讲</span>
                                <span class="right-text">
                                    唐山市政协副主席、市工商联主席&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;甄德恩<br>
                                    河北唐宋大数据产业股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                    中国工程院院士、中国金属学会理事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;干勇<br>
                                    全联冶金商会副会长兼常务秘书长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;王连忠<br>
                                    工业和信息化部原材料工业司钢铁处处长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;徐文立<br>
                                    德龙集团、新天钢集团董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;丁立国<br>
                                    天津友发钢管集团股份有限公司董事长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;李茂津
                                </span>
                                <a class="shuline" style="height: 240px;"></a>
                            </p>
                            <p class="time-line-content" style="margin-top: 15px;">
                                <span class="fontWhite font14">12:00 - 13:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">午餐</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">13:30 - 15:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">致辞演讲</span>
                                <span class="right-text">
                                    中国炼焦行业协会会长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;曹丕江<br>
                                    中国废钢铁应用协会常务副会长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;李树斌<br>
                                    迁安正大制管副总经理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;白向峰<br>
                                    天津友发钢管集团股份有限公司销售部长&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;陈卓
                                </span>
                                <a class="shuline" style="height: 175px;"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:30 - 16:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《钢铁行业原料行情分析及期权套保应用》<br>
                                    <span class="right-intro">东亚期货研究院副总监 王润雨</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:00 - 16:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《2021钢铁市场走势分析》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司副总经理 马强</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">16:30 - 17:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">中国钢铁产业网十佳企业颁奖</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content mt30">
                                <span class="fontWhite font14">18:00 - 20:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">晚宴</span>
                                <!-- <a class="shuline" style="height: 40px"></a> -->
                            </p>
                        </div>

                        
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;嘉&nbsp;&nbsp;&nbsp;宾&nbsp;&nbsp;&nbsp;介&nbsp;&nbsp;&nbsp;绍</span></p>
                    <div class="meeting-jbjs center mt40">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="">
                                    <img src="../../assets/images/ej/zhendeen.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">唐山市政协副主席、市工商联主席甄德恩致辞</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="">
                                    <img src="../../assets/images/ej/songlei.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">河北唐宋大数据产业股份有限公司董事长宋雷致辞并演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="">
                                    <img src="../../assets/images/ej/ganyong.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">中国工程院院士、中国金属学会理事长干勇演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/xuwenli.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">工业和信息化部原材料工业司钢铁处处长徐文立</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/wanglianzhong.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">全联冶金商会副会长兼常务副秘书长王连忠致辞并演讲 </p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/limaojin.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">天津友发钢管集团股份有限公司董事长李茂津主题演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/cuipijiang.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">中国炼焦行业协会会长崔丕江主题演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/lishubin.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">中国废钢铁应用协会常务副会长李树斌主题演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/baixiangfeng.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">正大制管经营中心副总监 迁安正大副总经理白向锋主题演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/chenzhuo.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">友发集团销售公司销售部长陈卓主题演讲</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/wangrunyu.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">东亚期货研究院副总监王润雨主题演讲 </p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="mt30">
                                    <img src="../../assets/images/ej/maqiang.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px;">河北唐宋大数据产业股份有限公司副总经理马强主题演讲</p>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;精&nbsp;&nbsp;&nbsp;彩&nbsp;&nbsp;&nbsp;仪&nbsp;&nbsp;&nbsp;式</span></p>
                    <div id="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/ej/gangtieshengchan.jpg" alt="" height="150px">
                            <p>十佳钢铁生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/ej/maoyi.jpg" alt="" height="150px">
                            <p>十佳钢铁综合贸易企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/ej/gangguan.jpg" alt="" height="150px">
                            <p>十佳钢管制造企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/ej/wuliu.jpg" alt="" height="150px">
                            <p>十佳钢铁物流企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/ej/jiaohua.jpg" alt="" height="150px">
                            <p>十佳焦化生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/ej/gangjiagong.jpg" alt="" height="150px">
                            <p>十佳钢加工企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(6)">
                            <img src="../../assets/images/ej/gangjiegou.jpg" alt="" height="150px">
                            <p>十佳钢结构生产企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(7)">
                            <img src="../../assets/images/ej/feigang.jpg" alt="" height="150px">
                            <p>十佳废钢铁回收加工企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(8)">
                            <img src="../../assets/images/ej/qihuo.jpg" alt="" height="150px">
                            <p>十佳期货企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(9)">
                            <img src="../../assets/images/ej/fuwu.jpg" alt="" height="150px">
                            <p>十佳服务企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(9)">
                            <img src="../../assets/images/ej/fuwu.jpg" alt="" height="150px">
                            <p>十佳服务企业</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(10)">
                            <img src="../../assets/images/ej/tiekuangshigy.jpg" alt="" height="150px">
                            <p>十佳铁矿石供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(11)">
                            <img src="../../assets/images/ej/meijiaogy.jpg" alt="" height="150px">
                            <p>十佳煤焦供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(12)">
                            <img src="../../assets/images/ej/gangpigy.jpg" alt="" height="150px">
                            <p>十佳钢坯供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(13)">
                            <img src="../../assets/images/ej/xingganggy.jpg" alt="" height="150px">
                            <p>十佳型钢供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(14)">
                            <img src="../../assets/images/ej/bancaigy.jpg" alt="" height="150px">
                            <p>十佳板材供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(15)">
                            <img src="../../assets/images/ej/jiancaigy.jpg" alt="" height="150px">
                            <p>十佳建材供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(16)">
                            <img src="../../assets/images/ej/daiganggy.jpg" alt="" height="150px">
                            <p>十佳带钢供应商</p>
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(17)">
                            <img src="../../assets/images/ej/guancaigy.jpg" alt="" height="150px">
                            <p>十佳钢管供应商</p>
                        </div>
                    </div>
                    <!-- 十佳放大效果 -->
                    <el-dialog title="" :visible.sync="dialogVisible" width="60%">
                        <el-row :gutter="20">
                            <el-col :span="16">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <p v-for="(item, index) in sjDetailData" :key="index" style="line-height: 50px; font-size: 18px; color: #333;">{{item}}</p>
                            </el-col>
                        </el-row>
                    </el-dialog>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;助</span></p>
                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">全联冶金商会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">日照大宗商品交易中心</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">上海东亚期货有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">承办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8"><!-- :offset="8"-->
                                <div class="zanzhu-center">中国钢铁产业网</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">联合主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">中国钢铁工业协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">中国炼焦行业协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">中国废钢铁应用协会</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">陕西钢铁集团</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">山西建邦集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">山西晋南钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北普阳钢铁集团</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">秦皇岛宏兴钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">天津友发钢管集团股份有限公司</div>
                            </el-col>
                             <el-col :span="8">
                                <div class="zanzhu-left">山东天保工贸有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">上海鸿网供应链股份有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">协办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">河北盛泰制管有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北津西钢铁集团股份有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">唐山市德龙钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北东海特钢集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">天津荣程联合钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">河北鑫达钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">河北安丰钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">ZDP正大制管</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">赞助单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">秦皇岛佰工钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">唐山金马钢铁集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">厦门海翼国际贸易有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">大益茶唐山金域华府体验馆</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;大&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px" class="mw-modular-box fontWhite textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">唐山香格里拉大酒店</h3>
                        <p style="line-height: 40px; font-size:24px">河北省唐山市路北区长虹西道889号</p>
                        <p style="line-height: 40px; font-size:16px">会址距唐山三女河机场约 30分钟车程，距唐山火车站10分钟车程。</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/search/%E5%94%90%E5%B1%B1%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97/@13152946.464129321,4788565.55,19z?querytype=s&da_src=shareurl&wd=%E5%94%90%E5%B1%B1%E9%A6%99%E6%A0%BC%E9%87%8C%E6%8B%89%E5%A4%A7%E9%85%92%E5%BA%97&c=265&src=0&pn=0&sug=0&l=15&b=(13148447,4789302;13163807,4796350)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1" target="_blank">
                            <img src="../../assets/images/ej/location.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 fontWhite mt40">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;服务热线：400-6565-958&nbsp;&nbsp;&nbsp;&nbsp;电话：0315-5921001/400-6565-958 <br>
                        传真：0315-5921091/5921092&nbsp;&nbsp;&nbsp;&nbsp;E-mail：info@chinatsi.com
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_down.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋app</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/footer_code.png" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋大数据</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'ActivitiesDetail',
    components: { ConcatsControl },
    data() {
        return {
            adIDsIndex: [{
                name: 'zx39',
                id: adIDs['zx39'],
                list: []
            }],
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/ej/gangtieshengchan.jpg'),
                require('../../assets/images/ej/maoyi.jpg'),
                require('../../assets/images/ej/gangguan.jpg'),
                require('../../assets/images/ej/wuliu.jpg'),
                require('../../assets/images/ej/jiaohua.jpg'),
                require('../../assets/images/ej/gangjiagong.jpg'),
                require('../../assets/images/ej/gangjiegou.jpg'),
                require('../../assets/images/ej/feigang.jpg'),
                require('../../assets/images/ej/qihuo.jpg'),
                require('../../assets/images/ej/fuwu.jpg'),
                require('../../assets/images/ej/tiekuangshigy.jpg'),
                require('../../assets/images/ej/meijiaogy.jpg'),
                require('../../assets/images/ej/gangpigy.jpg'),
                require('../../assets/images/ej/xingganggy.jpg'),
                require('../../assets/images/ej/bancaigy.jpg'),
                require('../../assets/images/ej/jiancaigy.jpg'),
                require('../../assets/images/ej/daiganggy.jpg'),
                require('../../assets/images/ej/guancaigy.jpg'),
            ],
            imgsDetailNames: [
                ['河北普阳钢铁有限公司', '河北津西钢铁集团股份有限公司', '秦皇岛宏兴钢铁有限公司', '唐山市德龙钢铁有限公司', '山西晋南钢铁集团有限公司', '河北天柱钢铁集团有限公司', '天津荣程联合钢铁集团有限公司', '唐山东华钢铁企业集团有限公司', '河北安丰钢铁有限公司', '江苏徐钢钢铁集团有限公司'], // 钢铁生产企业
                ['厦门海翼国际贸易有限公司', '浙江物产金属集团有限公司', '中基宁波集团股份有限公司', '成大物产（厦门）有限公司', '浙商中拓集团股份有限公司', '山东天保工贸有限公司', '天津启润投资有限公司', '苏美达国际技术贸易有限公司', '杭州热联集团股份有限公司', '江苏象石实业股份有限公司'], // 综合贸易企业
                ['新绛天地和金属制品有限公司', '天津市群胜达钢管有限公司', '天津友发钢管集团股份有限公司', '山东舜世高科实业有限公司', 'ZDP正大制管有限公司', '霸州市众丰金属制品有限公司', '天津市可楠钢管有限公司', '天津市宝来工贸有限公司', '河北盛泰制管有限公司', '天津市利达钢管集团有限公司'], // 钢管制造企业
                ['唐山海翼宏润物流有限公司', '浙江物产物流投资有限公司唐山分公司', '厦门国贸启铭物流有限公司', '唐山市丰领物流有限公司', '四川乐送物流股份有限公司', '河北兴泰物流有限公司', '唐山象屿正丰国际物流有限公司', '唐山市双赢物流有限公司', '邯郸新铁物流有限公司', '唐山东方海运有限公司'], // 钢铁物流企业
                ['唐山友利焦化有限公司', '武安市广普焦化有限公司', '介休市昌盛煤气化有限公司', '山西安泰集团股份有限公司', '唐山东方炼焦制气有限公司', '乌海市广纳煤焦化有限公司', '河北华丰能源科技发展有限公司', '山西潞宝集团焦化有限公司', '唐山达丰焦化有限公司', '山西亚鑫煤焦化有限公司'], // 焦化生产企业
                ['秦皇岛顺先钢铁有限公司', '天津市震翔板带加工有限公司', '唐山市丰润区鸿翔金属制品有限公司', '唐山首唐宝生功能材料有限公司', '唐山如隆实业有限公司', '唐山市丰润区鑫通源扁钢厂', '唐山宏润实业有限公司', '唐山市德物精密制品有限公司 ', '江苏卓群金属科技有限公司', '唐山市丰润区永强轧钢厂'], //钢加工企业
                ['河北津西新材料科技有限公司', '泊头市宝发彩钢钢构工程有限公司', '庆云华兴钢架工程有限公司', '宏德瑞琳金属结构制造有限公司', '邯郸市银蝉贸易有限公司', '潍坊长安铁塔股份有限公司', '天津市鑫跃达工贸有限公司', '邯郸市泽业贸易有限公司', '邯郸市恒特板材加工有限公司', '邯郸市华威钢结构工程有限公司'], // 钢结构生产企业
                ['本溪市远通物资回收有限公司', '朝阳议通金属再生资源有限公司', '天津城矿再生资源回收有限公司', '武安市永鑫再生资源利用有限公司', '天津德邦（邢台县）再生资源利用有限公司', '扬州鸿蓝钢铁加工有限公司', '天津振泓再生资源有限公司', '天津宏业兴再生物资回收有限公司', '浙商中拓集团江西再生资源有限公司', '河南冀物再生资源有限公司'], // 废钢回收加工企业
                ['上海东亚期货有限公司', '中辉期货有限公司', '宏源期货有限公司', '徽商期货有限责任公司', '永安期货股份有限公司', '国投安信期货有限公司', '国泰君安期货有限公司', '银河期货有限公司', '国海良时期货有限公司', '中国国际期货股份有限公司'], // 期货企业
                ['辽宁海力特种石油装备有限公司', '上海鸿网供应链股份有限公司', '中国检验认证集团河北有限公司', '钢谷电子商务股份有限公司', '德邻智联（鞍山）有限公司', '日照大宗商品交易中心', '中瑞和（天津）供应链管理服务有限公司', '唐山曹妃甸实业港务有限公司', '北京恒润九州实业有限公司', '秦皇岛佰工钢铁有限公司'], // 服务企业
                ['厦门国贸集团股份有限公司', '唐山凯荣国际贸易有限公司', '中航国际钢铁贸易有限公司', '天津锦亿供应链管理有限公司', '嘉吉投资（中国）有限公司', '浙江物产金属集团有限公司', '河钢集团北京国际贸易有限公司', '山东建邦联合进出口有限公司', '山东环富国际贸易有限公司', '日照兴业集团有限公司'], //铁矿石供应商
                ['唐山和朋贸易有限公司', '山东中垠国际贸易有限公司', '唐山永联国际贸易有限责任公司', '山东冀中瀚能供应链管理有限公司', '唐山市五山商贸有限公司', '厦门象屿股份有限公司', '易大宗（北京）供应链管理有限公司', '山东潍焦集团薛城能源有限公司', '山西省焦炭集团经销贸易有限公司', '重庆喜丰春瑞供应链管理有限公司'], // 煤焦供应商
                ['天津瑞鑫昌科技有限公司', '河北港济实业有限公司', '河北港禾实业发展有限公司', '浙江开迪贸易有限公司', '江阴市铁实供应链有限公司', '上海俱丰供应链有限公司', '迁安市瑞虎商贸有限公司', '唐山市晨丰商贸有限公司', '天津市仁通钢铁有限公司', '唐山海瀚国际贸易有限公司'], // 钢坯供应商
                ['唐山市丰润区乔羽贸易有限公司', '山西浩正鸿瑞贸易有限公司', '河北华贸电力新材料有限公司', '宁波荣城金属材料有限公司', '鞍山市鑫华通贸易有限公司', '唐山市丰润区超翼商贸有限公司', '邯郸市裕驰贸易有限公司', '泰安市延峰物资有限公司', '唐山市丰润区建源商贸有限公司', '唐山朗威进出口贸易有限公司'], // 型钢供应商
                ['汇金工贸（天津）有限公司', '邯郸市钢盈贸易有限公司', '山东新乐华钢铁有限公司', '青岛鸿利宇供应链有限公司', '邯郸市泰虎贸易有限公司', '河北邯城贸易有限公司', '河北泰岳峰钢铁贸易有限公司', '唐山市炳旭实业有限公司', '中船重工物资贸易集团有限公司', '邯郸市晟德贸易有限公司'], // 板材供应商
                ['辽宁紫中供应链有限责任公司', '河南豫之钢贸易有限公司', '万豪钢铁集团有限公司', '任丘市亚丰建筑器材有限公司', '中铁铁龙（营口）国际物流贸易有限公司', '唐山宏腾贸易有限公司', '陕钢集团韩城钢铁有限责任公司', '福建点增贸易有限公司', '山西兴合邦物资有限公司', '山东蓝天新材料科技有限公司'], // 建材供应商
                ['天津市仁翼博爱国际商贸有限公司', '无锡市启升金属材料有限公司', '天津市宏英丰达金属材料销售有限公司', '瑞信国际贸易有限公司', '天津市智恒达商贸有限公司', '迁安市瑞虎商贸有限公司', '天津市丰隆商贸有限公司', '天津中拓电子商务有限公司', '上海塔杰实业有限公司', '天津勤兴敬业科技有限公司'], // 带钢供应商
                ['天津市民阁商贸有限公司', '广州市华利丰钢材贸易有限公司', '南京友发物资有限公司', '奎鑫钢首集团', '唐山市青坤贸易有限公司', '霸州市广义制管有限公司', '天津海翼钢铁销售有限公司', '天津德汇钢铁贸易有限公司', '天津宏盛强钢铁有限公司', '天津市德健钢管有限公司'], // 钢管供应商
            ],
            sjDetailData: []
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.getAdByAdp();
        this.marqueeInit();
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    // direction: 'up',
                    // loop: -1,
                    scrollamount: 30,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            // console.log('进来了')
            this.dialogImg = this.imgs[index];
            this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg.png') no-repeat;
        background-size: 100% 100%;
        width: 600px;
        height: 60px;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #024e9a;
        padding-left: 20px;
        color: #fff;
    }
    .line { border-top: 1px solid #024e9a; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #024e9a;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
    }
    .time-line-content .right-intro {
        color: #024e9a;
        font-size: 14px;
        line-height: 40px;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #fff;
        top: 20px;
        left: 136px;
    }
    .meeting-jbjs {
        border: 8px solid #0350a0;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #d6be98;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #0350a0; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #d6be98; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #ffd79f; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 50px;
    }
    .address-bg img { width: 1000px; }
    .meeting-concat { width: 1000px; }
</style> 